export const idPattern = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const asciiPattern = /^[\x20-\x7e]*$/;
